import React from 'react'
import { Col } from 'react-bootstrap'

export default function DynamicMenuCard({
  handleMenuCallback,
  icon = null,
  name = '',
  description = '',
  key,
}) {
  return (
    <Col
      onClick={handleMenuCallback}
      xs={'auto'}
      sm={'auto'}
      md={'auto'}
      key={key}
      className='account-menu-card'>
      <img width={52} height={40} src={icon} />
      <h2>{name}</h2>
      <span>{description}</span>
    </Col>
  )
}
